// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DetailSection-module__font-s-10___pVVW5 {
  font-size: 10px !important;
}

.DetailSection-module__font-s-12___BVEWB {
  font-size: 12px !important;
}

.DetailSection-module__font-s-13___lBLuU {
  font-size: 13px !important;
}

.DetailSection-module__font-s-14___ogqW0 {
  font-size: 14px !important;
}

.DetailSection-module__font-s-15___dHrwF {
  font-size: 15px !important;
}

.DetailSection-module__font-s-16___WMsJj {
  font-size: 16px !important;
}

.DetailSection-module__font-s-18___oHuJM {
  font-size: 18px !important;
}

.DetailSection-module__font-s-20___XtWgV {
  font-size: 20px !important;
}

.DetailSection-module__font-s-22___gFLj0 {
  font-size: 22px !important;
}

.DetailSection-module__font-s-28___L70td {
  font-size: 28px !important;
}

.DetailSection-module__font-w-400___OutPA {
  font-weight: 400 !important;
}

.DetailSection-module__font-w-500___I3VpN {
  font-weight: 500 !important;
}

.DetailSection-module__font-w-600___B4H1L {
  font-weight: 600 !important;
}

.DetailSection-module__font-w-700___ApDex {
  font-weight: 700 !important;
}

.DetailSection-module__p-5___DGZme {
  padding: 5px !important;
}

.DetailSection-module__p-12___FNTWX {
  padding: 12px !important;
}

.DetailSection-module__p-16___Ymxr_ {
  padding: 16px !important;
}

.DetailSection-module__p-30___HogT5 {
  padding: 30px !important;
}

.DetailSection-module__p-b-0___DxUAZ {
  padding-bottom: 0 !important;
}

.DetailSection-module__p-b-5___AyDCe {
  padding-bottom: 5px !important;
}

.DetailSection-module__p-b-10___fd0hK {
  padding-bottom: 10px !important;
}

.DetailSection-module__p-b-12___jkBxs {
  padding-bottom: 12px !important;
}

.DetailSection-module__p-b-16___JB6v3 {
  padding-bottom: 16px !important;
}

.DetailSection-module__p-b-18___nW8PW {
  padding-bottom: 18px !important;
}

.DetailSection-module__p-b-20___Ug4fC {
  padding-bottom: 20px !important;
}

.DetailSection-module__p-b-25___LeDGq {
  padding-bottom: 25px !important;
}

.DetailSection-module__p-b-30___NcdKE {
  padding-bottom: 30px !important;
}

.DetailSection-module__p-b-50___L9sei {
  padding-bottom: 50px !important;
}

.DetailSection-module__p-t-0___mOeqS {
  padding-top: 0 !important;
}

.DetailSection-module__p-t-12___p0VuV {
  padding-top: 12px !important;
}

.DetailSection-module__p-t-16___cEYG3 {
  padding-top: 16px !important;
}

.DetailSection-module__p-t-18___cYTwB {
  padding-top: 18px !important;
}

.DetailSection-module__p-t-20___Ze7i4 {
  padding-top: 20px !important;
}

.DetailSection-module__p-t-30___ySou7 {
  padding-top: 30px !important;
}

.DetailSection-module__p-t-40___W0m8U {
  padding-top: 40px !important;
}

.DetailSection-module__p-t-50___vHM4q {
  padding-top: 50px !important;
}

.DetailSection-module__p-l-20___Utlrr {
  padding-left: 20px !important;
}

.DetailSection-module__p-l-30___yBaZk {
  padding-left: 30px !important;
}

.DetailSection-module__p-l-40___EkybL {
  padding-left: 40px !important;
}

.DetailSection-module__p-r-16___WhbF1 {
  padding-right: 16px !important;
}

.DetailSection-module__p-r-20___C3s6q {
  padding-right: 20px !important;
}

.DetailSection-module__p-r-30___fHdFc {
  padding-right: 30px !important;
}

.DetailSection-module__p-r-50___QPZWU {
  padding-right: 50px !important;
}

.DetailSection-module__p-r-60___lGATk {
  padding-right: 60px !important;
}

.DetailSection-module__m-b-1____m0NY {
  margin-bottom: 1px !important;
}

.DetailSection-module__m-b-2___yMQZm {
  margin-bottom: 2px !important;
}

.DetailSection-module__m-b-6___DzbW_ {
  margin-bottom: 6px !important;
}

.DetailSection-module__m-b-8___j4ze1 {
  margin-bottom: 8px !important;
}

.DetailSection-module__m-b-10___NFZCF {
  margin-bottom: 10px !important;
}

.DetailSection-module__m-b-14___di1Ek {
  margin-bottom: 14px !important;
}

.DetailSection-module__m-b-16___tsuFX {
  margin-bottom: 16px !important;
}

.DetailSection-module__m-b-20___B0Dm8 {
  margin-bottom: 20px !important;
}

.DetailSection-module__m-b-22___MlIxG {
  margin-bottom: 22px !important;
}

.DetailSection-module__m-b-24___jH_QL {
  margin-bottom: 24px !important;
}

.DetailSection-module__m-b-30___CBspX {
  margin-bottom: 30px !important;
}

.DetailSection-module__m-b-32___aGfLr {
  margin-bottom: 32px !important;
}

.DetailSection-module__m-b-40___T_xlz {
  margin-bottom: 40px !important;
}

.DetailSection-module__m-t-2___o0X2O {
  margin-top: 2px !important;
}

.DetailSection-module__m-t-3___rx0Sp {
  margin-top: 3px !important;
}

.DetailSection-module__m-t-4___StY4P {
  margin-top: 4px !important;
}

.DetailSection-module__m-t-5___U_j7S {
  margin-top: 5px !important;
}

.DetailSection-module__m-t-8___k67yA {
  margin-top: 8px !important;
}

.DetailSection-module__m-t-10___avJrj {
  margin-top: 10px !important;
}

.DetailSection-module__m-t-15___xvEqa {
  margin-top: 15px !important;
}

.DetailSection-module__m-t-16___T2KeG {
  margin-top: 16px !important;
}

.DetailSection-module__m-t-20___gzDhT {
  margin-top: 20px !important;
}

.DetailSection-module__m-t-22___c6kDh {
  margin-top: 22px !important;
}

.DetailSection-module__m-t-30___uGuCn {
  margin-top: 30px !important;
}

.DetailSection-module__m-t-32___uuteW {
  margin-top: 32px !important;
}

.DetailSection-module__m-l-auto___sH8DL {
  margin-left: auto !important;
}

.DetailSection-module__m-l-4___r03tF {
  margin-left: 4px !important;
}

.DetailSection-module__m-l-5___v3CCK {
  margin-left: 5px !important;
}

.DetailSection-module__m-l-6___kxpQR {
  margin-left: 6px !important;
}

.DetailSection-module__m-l-8___IQZk9 {
  margin-left: 8px !important;
}

.DetailSection-module__m-l-10___CVCLk {
  margin-left: 10px !important;
}

.DetailSection-module__m-l-16___bJBfd {
  margin-left: 16px !important;
}

.DetailSection-module__m-l-20___ER5Kh {
  margin-left: 20px !important;
}

.DetailSection-module__m-l-24___AW5z9 {
  margin-left: 24px !important;
}

.DetailSection-module__m-l-30___BbIbD {
  margin-left: 30px !important;
}

.DetailSection-module__m-l-35___ZCoKV {
  margin-left: 35px !important;
}

.DetailSection-module__m-l-40___Osu74 {
  margin-left: 40px !important;
}

.DetailSection-module__m-r-8___AJd3U {
  margin-right: 8px !important;
}

.DetailSection-module__m-r-10___woSc0 {
  margin-right: 10px !important;
}

.DetailSection-module__m-r-16___VXH8V {
  margin-right: 16px !important;
}

.DetailSection-module__m-r-20___yFeHg {
  margin-right: 20px !important;
}

.DetailSection-module__m-r-24___OrfJ8 {
  margin-right: 24px !important;
}

.DetailSection-module__m-r-30___RGOCa {
  margin-right: 30px !important;
}

.DetailSection-module__m-r-40___tQM0R {
  margin-right: 40px !important;
}

.DetailSection-module__border-r-3___Gi6_X {
  border-radius: 3px !important;
}

.DetailSection-module__border-r-4___WvFFr {
  border-radius: 4px !important;
}

.DetailSection-module__border-r-6___GdnZH {
  border-radius: 6px !important;
}

.DetailSection-module__border-r-10___VQZDO {
  border-radius: 10px !important;
}

.DetailSection-module__border-r-12___XUD4D {
  border-radius: 12px !important;
}

.DetailSection-module__border-r-16___k9y_6 {
  border-radius: 16px !important;
}

.DetailSection-module__border-r-50___hO2ut {
  border-radius: 50% !important;
}

.DetailSection-module__primary-border___tiPbr {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.DetailSection-module__primary-border-b___lgMmk {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.DetailSection-module__primary-border-t___hxtGj {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.DetailSection-module__primary-border-l___nqO7v {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.DetailSection-module__primary-border-r___IYu_E {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.DetailSection-module__secondary-border___lDFwf {
  border: 1px solid #637768;
}

.DetailSection-module__secondary-border-b___A9sU3 {
  border-bottom: 1px solid #637768;
}

.DetailSection-module__secondary-border-t___RsDC3 {
  border-top: 1px solid #637768;
}

.DetailSection-module__secondary-border-l___PEoEG {
  border-left: 1px solid #637768;
}

.DetailSection-module__secondary-border-r___G7hYe {
  border-right: 1px solid #637768;
}

.DetailSection-module__gap-0___s9Aky {
  gap: 0 !important;
}

.DetailSection-module__gap-2___R5t_m {
  gap: 2px !important;
}

.DetailSection-module__gap-4___v2SGJ {
  gap: 4px !important;
}

.DetailSection-module__gap-5___Q6IBH {
  gap: 5px !important;
}

.DetailSection-module__gap-6___CpAnV {
  gap: 6px !important;
}

.DetailSection-module__gap-8___tSkvY {
  gap: 8px !important;
}

.DetailSection-module__gap-10___duejB {
  gap: 10px !important;
}

.DetailSection-module__gap-12___GLTsT {
  gap: 12px !important;
}

.DetailSection-module__gap-14____rxj5 {
  gap: 14px !important;
}

.DetailSection-module__gap-16___rtEV1 {
  gap: 16px !important;
}

.DetailSection-module__gap-18___A1mrP {
  gap: 18px !important;
}

.DetailSection-module__gap-20___PNPEN {
  gap: 20px !important;
}

.DetailSection-module__gap-24___Lo36_ {
  gap: 24px !important;
}

.DetailSection-module__gap-26___xLTc1 {
  gap: 26px !important;
}

.DetailSection-module__gap-30___z8WEz {
  gap: 30px !important;
}

.DetailSection-module__gap-32___yfjsZ {
  gap: 32px !important;
}

.DetailSection-module__gap-40___UfTXp {
  gap: 40px !important;
}

.DetailSection-module__gap-50___fo5z1 {
  gap: 50px !important;
}

.DetailSection-module__flex-1___rYdJ0 {
  flex: 1;
}

.DetailSection-module__flex-none___whw3L {
  flex: none !important;
}

.DetailSection-module__flex-column___ZpYGa {
  display: flex;
  flex-direction: column !important;
}

.DetailSection-module__flex-row___L0oXh {
  display: flex;
  flex-direction: row !important;
}

.DetailSection-module__vertically-centered___fhlbD {
  display: flex;
  align-items: center !important;
}

.DetailSection-module__horizontally-centered___zaaE3 {
  display: flex;
  justify-content: center !important;
}

.DetailSection-module__horizontally-end___JVolj {
  display: flex;
  justify-content: end !important;
}

.DetailSection-module__vertically-start___hvXms {
  display: flex;
  align-items: start !important;
}

.DetailSection-module__space-between___Krzre {
  display: flex;
  justify-content: space-between !important;
}

.DetailSection-module__flex-wrap___eEDuZ {
  flex-wrap: wrap !important;
}

.DetailSection-module__height-100___lR9DB {
  height: 100%;
}

.DetailSection-module__width-50___spaBw {
  width: 50% !important;
}

.DetailSection-module__width-100___L6lja {
  width: 100%;
}

.DetailSection-module__cursor-pointer___JKdaZ {
  cursor: pointer;
}

.DetailSection-module__cursor-not-allowed___oNlox {
  cursor: not-allowed !important;
}

.DetailSection-module__absolute-centered___zLsVT {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.DetailSection-module__absolute___Up8W1 {
  position: absolute;
}

.DetailSection-module__relative___oDtDg {
  position: relative;
}

.DetailSection-module__fixed___yThPR {
  position: fixed;
}

.DetailSection-module__visible___DI851 {
  opacity: 1;
}

.DetailSection-module__invisible___uBJZw {
  opacity: 0;
}

.DetailSection-module__col-90___C7kMT {
  width: 90% !important;
}

.DetailSection-module__col-auto___bixVD {
  width: auto !important;
}

.DetailSection-module__medical-tabs___npkPV {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.DetailSection-module__medical-table-new___pZFpk {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.DetailSection-module__medical-table-new___pZFpk:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.DetailSection-module__medical-table-new___pZFpk::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.DetailSection-module__medical-table-new___pZFpk::-webkit-scrollbar-track {
  display: none;
}
.DetailSection-module__medical-table-new___pZFpk.DetailSection-module__no-pagination___suaRQ {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.DetailSection-module__medical-table-new___pZFpk.DetailSection-module__no-pagination___suaRQ:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.DetailSection-module__medical-table-new___pZFpk.DetailSection-module__no-pagination___suaRQ::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.DetailSection-module__medical-table-new___pZFpk.DetailSection-module__no-pagination___suaRQ::-webkit-scrollbar-track {
  display: none;
}

.DetailSection-module__medical-table-empty___VS4bj {
  padding: 14px 40px !important;
}

.DetailSection-module__icon-btn___XVIzT {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.DetailSection-module__search-icon___f2ZVB {
  width: 24px;
  height: 24px;
  align-self: center;
}

.DetailSection-module__disable-select___gogWr {
  user-select: none;
}

.DetailSection-module__break-word___OP0pz {
  word-break: break-word;
}

.DetailSection-module__popup-clear-btn___D2qnl {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.DetailSection-module__scroll-m-b-20___M54xG {
  scroll-margin-bottom: 20px;
}

.DetailSection-module__container___iLa3i {
  flex: 1;
  background-color: white;
  border-left: 1px solid #e0e3e6;
  position: relative;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/components/navigation/MasterDetailLayout/sections/DetailSection/DetailSection.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,OAAA;EACA,uBAAA;EACA,8BAAA;EACA,kBAAA;AA8pBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  flex: 1;\n  background-color: get-color(white);\n  border-left: 1px solid #e0e3e6;\n  position: relative;\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `DetailSection-module__font-s-10___pVVW5`,
	"fontS12": `DetailSection-module__font-s-12___BVEWB`,
	"fontS13": `DetailSection-module__font-s-13___lBLuU`,
	"fontS14": `DetailSection-module__font-s-14___ogqW0`,
	"fontS15": `DetailSection-module__font-s-15___dHrwF`,
	"fontS16": `DetailSection-module__font-s-16___WMsJj`,
	"fontS18": `DetailSection-module__font-s-18___oHuJM`,
	"fontS20": `DetailSection-module__font-s-20___XtWgV`,
	"fontS22": `DetailSection-module__font-s-22___gFLj0`,
	"fontS28": `DetailSection-module__font-s-28___L70td`,
	"fontW400": `DetailSection-module__font-w-400___OutPA`,
	"fontW500": `DetailSection-module__font-w-500___I3VpN`,
	"fontW600": `DetailSection-module__font-w-600___B4H1L`,
	"fontW700": `DetailSection-module__font-w-700___ApDex`,
	"p5": `DetailSection-module__p-5___DGZme`,
	"p12": `DetailSection-module__p-12___FNTWX`,
	"p16": `DetailSection-module__p-16___Ymxr_`,
	"p30": `DetailSection-module__p-30___HogT5`,
	"pB0": `DetailSection-module__p-b-0___DxUAZ`,
	"pB5": `DetailSection-module__p-b-5___AyDCe`,
	"pB10": `DetailSection-module__p-b-10___fd0hK`,
	"pB12": `DetailSection-module__p-b-12___jkBxs`,
	"pB16": `DetailSection-module__p-b-16___JB6v3`,
	"pB18": `DetailSection-module__p-b-18___nW8PW`,
	"pB20": `DetailSection-module__p-b-20___Ug4fC`,
	"pB25": `DetailSection-module__p-b-25___LeDGq`,
	"pB30": `DetailSection-module__p-b-30___NcdKE`,
	"pB50": `DetailSection-module__p-b-50___L9sei`,
	"pT0": `DetailSection-module__p-t-0___mOeqS`,
	"pT12": `DetailSection-module__p-t-12___p0VuV`,
	"pT16": `DetailSection-module__p-t-16___cEYG3`,
	"pT18": `DetailSection-module__p-t-18___cYTwB`,
	"pT20": `DetailSection-module__p-t-20___Ze7i4`,
	"pT30": `DetailSection-module__p-t-30___ySou7`,
	"pT40": `DetailSection-module__p-t-40___W0m8U`,
	"pT50": `DetailSection-module__p-t-50___vHM4q`,
	"pL20": `DetailSection-module__p-l-20___Utlrr`,
	"pL30": `DetailSection-module__p-l-30___yBaZk`,
	"pL40": `DetailSection-module__p-l-40___EkybL`,
	"pR16": `DetailSection-module__p-r-16___WhbF1`,
	"pR20": `DetailSection-module__p-r-20___C3s6q`,
	"pR30": `DetailSection-module__p-r-30___fHdFc`,
	"pR50": `DetailSection-module__p-r-50___QPZWU`,
	"pR60": `DetailSection-module__p-r-60___lGATk`,
	"mB1": `DetailSection-module__m-b-1____m0NY`,
	"mB2": `DetailSection-module__m-b-2___yMQZm`,
	"mB6": `DetailSection-module__m-b-6___DzbW_`,
	"mB8": `DetailSection-module__m-b-8___j4ze1`,
	"mB10": `DetailSection-module__m-b-10___NFZCF`,
	"mB14": `DetailSection-module__m-b-14___di1Ek`,
	"mB16": `DetailSection-module__m-b-16___tsuFX`,
	"mB20": `DetailSection-module__m-b-20___B0Dm8`,
	"mB22": `DetailSection-module__m-b-22___MlIxG`,
	"mB24": `DetailSection-module__m-b-24___jH_QL`,
	"mB30": `DetailSection-module__m-b-30___CBspX`,
	"mB32": `DetailSection-module__m-b-32___aGfLr`,
	"mB40": `DetailSection-module__m-b-40___T_xlz`,
	"mT2": `DetailSection-module__m-t-2___o0X2O`,
	"mT3": `DetailSection-module__m-t-3___rx0Sp`,
	"mT4": `DetailSection-module__m-t-4___StY4P`,
	"mT5": `DetailSection-module__m-t-5___U_j7S`,
	"mT8": `DetailSection-module__m-t-8___k67yA`,
	"mT10": `DetailSection-module__m-t-10___avJrj`,
	"mT15": `DetailSection-module__m-t-15___xvEqa`,
	"mT16": `DetailSection-module__m-t-16___T2KeG`,
	"mT20": `DetailSection-module__m-t-20___gzDhT`,
	"mT22": `DetailSection-module__m-t-22___c6kDh`,
	"mT30": `DetailSection-module__m-t-30___uGuCn`,
	"mT32": `DetailSection-module__m-t-32___uuteW`,
	"mLAuto": `DetailSection-module__m-l-auto___sH8DL`,
	"mL4": `DetailSection-module__m-l-4___r03tF`,
	"mL5": `DetailSection-module__m-l-5___v3CCK`,
	"mL6": `DetailSection-module__m-l-6___kxpQR`,
	"mL8": `DetailSection-module__m-l-8___IQZk9`,
	"mL10": `DetailSection-module__m-l-10___CVCLk`,
	"mL16": `DetailSection-module__m-l-16___bJBfd`,
	"mL20": `DetailSection-module__m-l-20___ER5Kh`,
	"mL24": `DetailSection-module__m-l-24___AW5z9`,
	"mL30": `DetailSection-module__m-l-30___BbIbD`,
	"mL35": `DetailSection-module__m-l-35___ZCoKV`,
	"mL40": `DetailSection-module__m-l-40___Osu74`,
	"mR8": `DetailSection-module__m-r-8___AJd3U`,
	"mR10": `DetailSection-module__m-r-10___woSc0`,
	"mR16": `DetailSection-module__m-r-16___VXH8V`,
	"mR20": `DetailSection-module__m-r-20___yFeHg`,
	"mR24": `DetailSection-module__m-r-24___OrfJ8`,
	"mR30": `DetailSection-module__m-r-30___RGOCa`,
	"mR40": `DetailSection-module__m-r-40___tQM0R`,
	"borderR3": `DetailSection-module__border-r-3___Gi6_X`,
	"borderR4": `DetailSection-module__border-r-4___WvFFr`,
	"borderR6": `DetailSection-module__border-r-6___GdnZH`,
	"borderR10": `DetailSection-module__border-r-10___VQZDO`,
	"borderR12": `DetailSection-module__border-r-12___XUD4D`,
	"borderR16": `DetailSection-module__border-r-16___k9y_6`,
	"borderR50": `DetailSection-module__border-r-50___hO2ut`,
	"primaryBorder": `DetailSection-module__primary-border___tiPbr`,
	"primaryBorderB": `DetailSection-module__primary-border-b___lgMmk`,
	"primaryBorderT": `DetailSection-module__primary-border-t___hxtGj`,
	"primaryBorderL": `DetailSection-module__primary-border-l___nqO7v`,
	"primaryBorderR": `DetailSection-module__primary-border-r___IYu_E`,
	"secondaryBorder": `DetailSection-module__secondary-border___lDFwf`,
	"secondaryBorderB": `DetailSection-module__secondary-border-b___A9sU3`,
	"secondaryBorderT": `DetailSection-module__secondary-border-t___RsDC3`,
	"secondaryBorderL": `DetailSection-module__secondary-border-l___PEoEG`,
	"secondaryBorderR": `DetailSection-module__secondary-border-r___G7hYe`,
	"gap0": `DetailSection-module__gap-0___s9Aky`,
	"gap2": `DetailSection-module__gap-2___R5t_m`,
	"gap4": `DetailSection-module__gap-4___v2SGJ`,
	"gap5": `DetailSection-module__gap-5___Q6IBH`,
	"gap6": `DetailSection-module__gap-6___CpAnV`,
	"gap8": `DetailSection-module__gap-8___tSkvY`,
	"gap10": `DetailSection-module__gap-10___duejB`,
	"gap12": `DetailSection-module__gap-12___GLTsT`,
	"gap14": `DetailSection-module__gap-14____rxj5`,
	"gap16": `DetailSection-module__gap-16___rtEV1`,
	"gap18": `DetailSection-module__gap-18___A1mrP`,
	"gap20": `DetailSection-module__gap-20___PNPEN`,
	"gap24": `DetailSection-module__gap-24___Lo36_`,
	"gap26": `DetailSection-module__gap-26___xLTc1`,
	"gap30": `DetailSection-module__gap-30___z8WEz`,
	"gap32": `DetailSection-module__gap-32___yfjsZ`,
	"gap40": `DetailSection-module__gap-40___UfTXp`,
	"gap50": `DetailSection-module__gap-50___fo5z1`,
	"flex1": `DetailSection-module__flex-1___rYdJ0`,
	"flexNone": `DetailSection-module__flex-none___whw3L`,
	"flexColumn": `DetailSection-module__flex-column___ZpYGa`,
	"flexRow": `DetailSection-module__flex-row___L0oXh`,
	"verticallyCentered": `DetailSection-module__vertically-centered___fhlbD`,
	"horizontallyCentered": `DetailSection-module__horizontally-centered___zaaE3`,
	"horizontallyEnd": `DetailSection-module__horizontally-end___JVolj`,
	"verticallyStart": `DetailSection-module__vertically-start___hvXms`,
	"spaceBetween": `DetailSection-module__space-between___Krzre`,
	"flexWrap": `DetailSection-module__flex-wrap___eEDuZ`,
	"height100": `DetailSection-module__height-100___lR9DB`,
	"width50": `DetailSection-module__width-50___spaBw`,
	"width100": `DetailSection-module__width-100___L6lja`,
	"cursorPointer": `DetailSection-module__cursor-pointer___JKdaZ`,
	"cursorNotAllowed": `DetailSection-module__cursor-not-allowed___oNlox`,
	"absoluteCentered": `DetailSection-module__absolute-centered___zLsVT`,
	"absolute": `DetailSection-module__absolute___Up8W1`,
	"relative": `DetailSection-module__relative___oDtDg`,
	"fixed": `DetailSection-module__fixed___yThPR`,
	"visible": `DetailSection-module__visible___DI851`,
	"invisible": `DetailSection-module__invisible___uBJZw`,
	"col90": `DetailSection-module__col-90___C7kMT`,
	"colAuto": `DetailSection-module__col-auto___bixVD`,
	"medicalTabs": `DetailSection-module__medical-tabs___npkPV`,
	"medicalTableNew": `DetailSection-module__medical-table-new___pZFpk`,
	"noPagination": `DetailSection-module__no-pagination___suaRQ`,
	"medicalTableEmpty": `DetailSection-module__medical-table-empty___VS4bj`,
	"iconBtn": `DetailSection-module__icon-btn___XVIzT`,
	"searchIcon": `DetailSection-module__search-icon___f2ZVB`,
	"disableSelect": `DetailSection-module__disable-select___gogWr`,
	"breakWord": `DetailSection-module__break-word___OP0pz`,
	"popupClearBtn": `DetailSection-module__popup-clear-btn___D2qnl`,
	"scrollMB20": `DetailSection-module__scroll-m-b-20___M54xG`,
	"container": `DetailSection-module__container___iLa3i`
};
module.exports = ___CSS_LOADER_EXPORT___;
